import Reactotron from 'reactotron-react-js';
import apisaucePlugin from 'reactotron-apisauce';

Reactotron
    .configure() // we can use plugins here -- more on this later
    .use(apisaucePlugin({}))
    .connect(); // let's connect!

// add reactotron to console
global.console.tron = Reactotron;